import React, { useMemo, Fragment, useContext, useEffect, useState, useRef } from 'react';
import { TelnyxRTC } from '@telnyx/webrtc';

const TelnyxRTCContext = /*#__PURE__*/React.createContext(null);

const initTelnyxRTC = ({
  credentialParam,
  clientOptions
}) => {
  const session = new TelnyxRTC({
    login_token: '',
    ...credentialParam,
    ...clientOptions
  });
  session.on('telnyx.error', () => {
    session === null || session === void 0 ? void 0 : session.disconnect();
  });
  session.on('telnyx.socket.error', () => {
    session === null || session === void 0 ? void 0 : session.disconnect();
  });
  session === null || session === void 0 ? void 0 : session.connect();
  return session;
};
function useTelnyxRTC(credentialParam, clientOptions) {
  const telnyxClient = useMemo(() => {
    var _client;
    let client;
    if ((_client = client) !== null && _client !== void 0 && _client.connected) {
      var _client2, _client3, _client4, _client5, _client6, _client7;
      if (process.env.NODE_ENV === 'development' && client) {
        console.warn('Instance of Telnyx Client already exists and will be disconnected.');
      }
      (_client2 = client) === null || _client2 === void 0 ? void 0 : _client2.disconnect();
      (_client3 = client) === null || _client3 === void 0 ? void 0 : _client3.off('telnyx.ready');
      (_client4 = client) === null || _client4 === void 0 ? void 0 : _client4.off('telnyx.error');
      (_client5 = client) === null || _client5 === void 0 ? void 0 : _client5.off('telnyx.notification');
      (_client6 = client) === null || _client6 === void 0 ? void 0 : _client6.off('telnyx.socket.close');
      (_client7 = client) === null || _client7 === void 0 ? void 0 : _client7.off('telnyx.socket.error');
      client = undefined;
      client = initTelnyxRTC({
        credentialParam,
        clientOptions
      });
    } else {
      client = initTelnyxRTC({
        credentialParam,
        clientOptions
      });
    }
    return client;
  }, [credentialParam.login_token, credentialParam.login, credentialParam.password]);
  return telnyxClient;
}

function TelnyxRTCProvider({
  children,
  credential,
  options
}) {
  const telnyxClient = useTelnyxRTC(credential, options);
  return /*#__PURE__*/React.createElement(TelnyxRTCContext.Provider, {
    value: telnyxClient || null
  }, /*#__PURE__*/React.createElement(Fragment, null, children));
}

function useCallbacks(props) {
  const telnyxClient = useContext(TelnyxRTCContext);
  useEffect(() => {
    if (telnyxClient) {
      if (props !== null && props !== void 0 && props.onReady) {
        telnyxClient.on('telnyx.ready', props.onReady);
      }
      if (props !== null && props !== void 0 && props.onError) {
        telnyxClient.on('telnyx.error', props.onError);
      }
      if (props !== null && props !== void 0 && props.onNotification) {
        telnyxClient.on('telnyx.notification', props.onNotification);
      }
      if (props !== null && props !== void 0 && props.onSocketError) {
        telnyxClient.on('telnyx.socket.error', props.onSocketError);
      }
      if (props !== null && props !== void 0 && props.onSocketClose) {
        telnyxClient.on('telnyx.socket.close', props.onSocketClose);
      }
    }
  }, [telnyxClient]);
  return null;
}

function useNotification() {
  const [notification, setNotification] = useState();
  useCallbacks({
    onNotification: setNotification
  });
  return notification;
}

function Media({
  type,
  stream,
  ...props
}) {
  const mediaRef = useRef();
  useEffect(() => {
    if (mediaRef.current && stream) {
      mediaRef.current.srcObject = stream;
    }
  }, [stream]);
  return /*#__PURE__*/React.createElement(type, {
    ref: mediaRef,
    autoPlay: true,
    ...props
  });
}
function Audio(props) {
  return /*#__PURE__*/React.createElement(Media, {
    type: 'audio',
    ...props
  });
}
function Video(props) {
  return /*#__PURE__*/React.createElement(Media, {
    type: 'video',
    playsInline: true,
    ...props
  });
}

export { Audio, Media, TelnyxRTCContext, TelnyxRTCProvider, Video, useCallbacks, useNotification, useTelnyxRTC };
//# sourceMappingURL=index.modern.js.map
